module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAP9JREFUOE+lkjFLw1AUhb/bJw7VQTCL/6D+ELdsgoFOcerg0A4ZHTo6dnFwMi6FFJwsdHD2PwgWunaoUIg6COGW1xqatpE86JnPd+697x1hD8mSvR8cc2JOnXPm2Sc3V1/C06CNaheYO8PgIXorxEkKTIGQMHirDIiTS6AHHFhY0ewcMS+VATmo2QViRis4DITHfgOpjUAiwuB5Z4MieN18J04ma9i6lwHmFehsBGyD1rsDlwWUgf/CmwFDwMfeaFctqnRybnjoexyKz68OaTVnJW+wdXPlPxUMf5NTvuXMNsaZtY080o+8YRHo2BlGGojcrbtdzzxn+MfMVt3eQwsO4n764qJXmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactEmail.png
// module id = rs/e
// module chunks = 13